import i18n from 'modules/core/lib/i18n'

import DateTimeRangeBlock from 'modules/expenses/components/expenses/Detail/_newForm/Blocks/DateTimeRange'
import TripBlock from 'modules/expenses/components/expenses/Detail/_newForm/Blocks/Trip'
import FormBlock from 'modules/expenses/components/expenses/Detail/_newForm/Sections/FormBlock'
import { CustomizationProps } from 'modules/expenses/components/expenses/Detail/_newForm/withCustomizationFields'
import { PermissionsProps } from 'modules/expenses/components/expenses/Detail/_newForm/withFieldPermissions'

interface Props extends PermissionsProps, CustomizationProps {
  loading: boolean
}

const TripInformation = (props: Props) => {
  return (
    <FormBlock
      title={i18n.t('expenses_v2.forms.new_form.blocks.trip_information')}
      subtitle={i18n.t('expenses_v2.forms.new_form.blocks.trip_information_subtitle')}
    >
      <TripBlock {...props} loading={props.loading} />
      <DateTimeRangeBlock {...props} loading={props.loading} />
    </FormBlock>
  )
}

export default TripInformation
